import {PayAccount} from '$share/types/account'
import {AssetType} from '$share/types/common'
import {EfinCategoryKeys} from '$share/types/efin/asset'
import {AssetOrg, Org} from '$share/types/organization'

export enum RegistrationStatus {
    NEW = 'N', // 신규
    REGISTRATION = 'R', // 등록
    DELETE = 'D', // 등록해제(데이터삭제)
    TEMPORAL_SAVE = 'T', // 1차 인증을 통한 최초 등록
}

export interface Asset {
    id: number // Asset ID
    org: AssetOrg
    seqno: string // 계좌: 회차번호, 카드: 카드식별자(card_id)
    name: string // 카드명
    nickname: string // 카드별명
    enabled: boolean // 노출상태
    status: RegistrationStatus // 자산 등록상태
    num: string // 카드번호
    assetType: AssetType // 자산타입
    consent: boolean | null // 마이데이터 전송요구 여부
    minus?: boolean // 마이너스 통장 여부
    createAt: string // 생성시각
    updateAt: string // 수정시각
    payAcc: PayAccount | null // 간편결제계좌
    imageUrl: string | null // 카드 플레이트 이미지 url
    category?: EfinCategoryKeys // 전금 카테고리
}

export interface AssetRegistrationStatus {
    bank: boolean
    invest: boolean
    card: boolean
    loan: boolean
    pension: boolean
    insu: boolean
    efin: boolean
    cardCard: Org['orgCode'][]
    cardBill: Org['orgCode'][]
    cardPoint: Org['orgCode'][]
    cardLoan: Org['orgCode'][]
}
